import type { CareerStat } from 'bundles/unified-career-academy/components/modules/hero/RolePageHeroCareerStats';

export const CareetStatsPrefix = 'rdpHeroCareerStats';
/**
 * This function pairs the description with its icon by converting
 * { rdpHeroCareerStats1Icon: 'MoneyIcon', rdpHeroCareerStats1Description: 'markdown' }
 * into
 * [{icon: 'MoneyIcon', description: 'markdown'}]
 */
const getCareerStats = (careerData?: Record<string, string>) => {
  let careerStats: CareerStat[] = [];
  if (!careerData) {
    return careerStats;
  }

  const regex = new RegExp(`^${CareetStatsPrefix}([0-9])(Icon|Description)$`);

  Object.keys(careerData).forEach((key) => {
    if (key && key.startsWith(CareetStatsPrefix)) {
      const match = key.match(regex);
      if (match === null) return;
      const index = Number(match[1]) - 1;
      if (careerStats[index] === undefined) {
        careerStats[index] = {};
      }
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      careerStats[index][match[2].toLowerCase() as keyof CareerStat] = careerData[key];
    }
  });
  careerStats = careerStats.filter((stat) => stat.description !== undefined && stat.description !== null);
  return careerStats;
};

export default getCareerStats;
